module.exports = __webpack_public_path__ + "static/media/icon-external.ccb2a8f0.svg";